<template>
    <div class="contact-container">
        <div class="top">福建邮你采科技有限公司</div>
        <div class="solve">
            <div class="f-label font_size_30">联系我们</div>
            <div class="s-label font_size_14">CONTACT US</div>
        </div>
        <div class="contact-methods">
            <div class="contact-methods-item">
                <img src="../../assets/ct_mobile@2x.png" class="item-img" />
                <div class="msg fw">联系电话</div>
                <div class="msg">15306997110</div>
            </div>
            <div class="contact-methods-item">
                <img src="../../assets/ct_email@2x.png" class="item-img" />
                <div class="msg fw">公司邮箱</div>
                <div class="msg">fjyounicai@sina.com</div>
            </div>
            <div class="contact-methods-item">
                <img src="../../assets/ct_address@2x.png" class="item-img" />
                <div class="msg fw">公司地址</div>
                <div class="msg adw">
                    福建省福州市长乐区文武砂街道东湖路1号中国东南大数据产业园研发楼二期1号楼501单元
                </div>
            </div>
            <el-button class="complain-btn" size="mini" @click="complain" round>投诉举报</el-button>
        </div>
        <div class="map" />
        <el-dialog
            title="投诉举报"
            :visible.sync="dialogFormVisible"
            :close-on-click-modal="false"
            @close="closeHandler"
            center
        >
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="您的姓名" prop="userName">
                    <el-input
                        v-model="form.userName"
                        clearable
                        placeholder="请输入您的姓名"
                        maxlength="15"
                        size="small"
                    ></el-input>
                </el-form-item>
                <el-form-item label="您的联系电话" prop="userPhone">
                    <el-input
                        v-model="form.userPhone"
                        clearable
                        placeholder="请输入您的联系电话"
                        size="small"
                    ></el-input>
                </el-form-item>
                <el-form-item label="问题类型" prop="questionType">
                    <el-select
                        v-model="form.questionType"
                        placeholder="请选择问题类型"
                        clearable
                        style="width: 100%"
                        size="small"
                    >
                        <el-option
                            v-for="item in typeOption"
                            :key="item.dictValue"
                            :value="item.dictValue"
                            :label="item.dictLabel"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="投诉举报内容" prop="questionContent">
                    <el-input
                        v-model="form.questionContent"
                        type="textarea"
                        rows="8"
                        placeholder="请输入投诉举报内容"
                        size="small"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="confirmHandler" size="small">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { request } from '@/api/auth'
export default {
    name: 'ContactPage',
    data() {
        return {
            dialogFormVisible: false,
            form: {
                userName: '',
                userPhone: '',
                questionType: '',
                questionContent: ''
            },
            typeOption: [],
            rules: {
                userName: [{ required: true, message: '请输入您的姓名', trigger: 'blur' }],
                userPhone: [
                    { required: true, message: '请输入您的联系电话', trigger: 'blur' },
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            const reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/
                            if (value == '' || value == undefined || value == null) {
                                callback()
                            } else {
                                if (!reg.test(value) && value != '') {
                                    callback(new Error('请输入正确的电话号码或者固话号码'))
                                } else {
                                    callback()
                                }
                            }
                        }
                    }
                ],
                questionType: [{ required: true, message: '请选择问题类型', trigger: 'change' }],
                questionContent: [
                    { required: true, message: '请输入投诉举报内容', trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        this.getDicts()
    },
    methods: {
        getDicts() {
            request.get('/mall/web/userQuestion/questionTypeList').then((response) => {
                this.typeOption = response.data
            })
        },

        confirmHandler() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    request
                        .post('/mall/web/userQuestion/saveQuestion', {
                            appType: 2,
                            ...this.form
                        })
                        .then(() => {
                            this.$message.success(
                                '您的投诉举报已提交成功，请等待系统客服处理，届时将电话联系您，请注意接听'
                            )
                            this.dialogFormVisible = false
                        })
                        .catch((error) => {
                            if (error.code === 500) {
                                this.$alert(`${error.msg}`, '提示', {})
                            }
                        })
                }
            })
        },

        closeHandler() {
            this.$refs['form'].resetFields()
            this.$refs['form'].clearValidate()
        },

        complain() {
            this.dialogFormVisible = true
            this.$nextTick(() => {
                this.$refs['form'].clearValidate()
            })
        }
    }
}
</script>

<style scoped lang="scss">
.contact-container {
    width: 100%;

    .el-dialog {
        width: 40vw;
    }

    .font_size_30 {
        font-size: 1.875em;
    }

    .font_size_14 {
        font-size: 0.875rem;
    }

    .solve {
        padding-top: 50px;
        padding-bottom: 15px;
        position: relative;

        .f-label {
            text-align: center;
            color: #157e3b;
        }

        .s-label {
            text-align: center;
            color: #aaaaaa;
            margin-top: 10px;
        }

        .more-img {
            position: absolute;
            right: 19%;
            top: 65px;
            width: 77px;
            height: 32px;
            background-image: url('../../assets/main/pic_more_nor@2x.png');
            background-size: 100% 100%;
        }
    }
    .top {
        width: 100%;
        height: 400px;
        background-image: url('../../assets/banner_ggdt@2x.png');
        background-size: 100% 100%;
        font-size: 3.3125rem;
        font-weight: bold;
        color: #ffffff;
        line-height: 400px;
        text-align: center;
    }

    .contact-methods {
        width: 1000px;
        margin: 14px auto;
        display: flex;
        justify-content: space-between;
        position: relative;

        &-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            .item-img {
                width: 84px;
                height: 84px;
            }

            .msg {
                font-size: 0.875rem;
                color: #000000;
                line-height: 20px;
                text-align: center;
                margin-top: 10px;
                width: 240px;
            }

            .fw {
                font-weight: bold;
            }
        }

        .complain-btn {
            position: absolute;
            top: -80px;
            right: 30px;
            background-color: #2f9458;
            color: #fff;
            border: #2f9458;
            width: 106px;
            height: 34px;
            text-align: center;
            border-radius: 18px;
            font-size: 0.875rem;
        }
    }

    .map {
        width: 935px;
        height: 475.69px;
        margin: 40px auto;
        background-image: url('../../assets/address.png');
        background-size: 100% 100%;
    }

    @media screen and (max-device-width: 768px) {
        ::v-deep .el-dialog {
            width: 90vw;
        }

        .font_size_30 {
            font-size: 0.9375rem; // 15px
        }

        .font_size_14 {
            font-size: 0.625rem; // 10px
        }

        .solve {
            width: 100%;
            padding-top: 14px;
            padding-bottom: 14px;
            position: relative;
            .f-label {
                text-align: center;
                color: #157e3b;
            }

            .s-label {
                text-align: center;
                color: #aaaaaa;
                margin-top: 6px;
            }

            .more-img {
                position: absolute;
                right: 16px;
                top: 20px;
                width: 48px;
                height: 20px;
                background-image: url('../../assets/main/pic_more_nor@2x.png');
                background-size: 100% 100%;
            }
        }
        .top {
            font-size: 1.125rem;
            height: 137px;
            width: 100%;
            line-height: 137px;
        }

        .contact-methods {
            width: auto;
            flex-wrap: wrap;
            justify-content: space-evenly;
            .contact-methods-item {
                width: 160px;
                margin-bottom: 20px;
                .item-img {
                    width: 66px;
                    height: 66px;
                }

                .msg {
                    width: auto;
                }

                .adw {
                    width: 240px;
                }
            }
            .complain-btn {
                position: absolute;
                top: -60px;
                right: 30px;
                // background-color: #2F9458;
                // color: #fff;
                // border:#2F9458;
                width: 75px;
                height: 26px;
                // text-align: center;
                // border-radius: 18px;
                font-size: 0.6875rem;
            }
        }

        .map {
            width: calc(100% - 32px);
            height: 175px;
            margin: 25px auto;
            background-image: url('../../assets/address.png');
            background-size: 100% 100%;
        }
    }

    @media screen and (min-device-width: 769px) and (max-device-width: 1100px) {
        .contact-methods {
            width: auto;
            flex-wrap: wrap;
            justify-content: space-evenly;
            .contact-methods-item {
                width: 160px;
            }
        }

        .map {
            width: calc(100% - 100px);
            margin: 25px auto;
            background-image: url('../../assets/address.png');
            background-size: 100% 100%;
        }
    }
}
</style>
